import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';

import { Input , TreeSelect } from 'antd'

import { Page,Crud } from '../../components'

const {CrudTable,CrudForm,CrudFilter,CrudButtons} = Crud

export class BenefitsPage extends Component {
  static propTypes = {
    system: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount(){
      const { getAllBenifits } = this.props.actions;
     const { benefitsPage,currentBenefits} = this.props.system;
     this.fetchList( benefitsPage);
       getAllBenifits();
  }

  fetchList = (page,values) => {
    const {getBenefitsList} = this.props.actions;
    let params = Object.assign({},{page:page},values)
    getBenefitsList(params);
  }

  getDataSource() {
    const { system } = this.props;
    const { benefitsById, benefitsList } = system;
    if (!benefitsList) return [];
    return benefitsList.map(id => benefitsById[id]);
  }

  get listProps() {
    const { system,actions } = this.props
    const { getBenefitsListPending,benefitsTotal,benefitsPage , originBenefitTypeTree} = system
    const { deleteBenefits,chooseCurrentBenefits,benefitsModalChange } = actions;

    return {
      dataSource: originBenefitTypeTree,
      loading: getBenefitsListPending,
      columns:[
        {
          title: "标签名",
          dataIndex: 'name',
          key: 'name',
          width: 180,
        },
        {
          title: "排序号",
          dataIndex: 'orderNum',
          key: 'orderNum',
          width: 180,
        },
      ],
      pagination:undefined,
      op:[
       {
          key:1,
          name:'编辑',
          buttonProps:{
            icon:"edit",
            type:"primary"
          },
        },
        {
          key:3,
          name:'删除',
          buttonProps:{
            icon:"delete",
            type:"danger"
          },
          needConfirm:true,
          confirmTitle:"确认删除"
        }
      ],
      handleMenuClick: (record,item) => {
        if (item.key == 1){
          chooseCurrentBenefits(record);
          benefitsModalChange(true,"updata");
        }else if(item.key == 3){
            deleteBenefits(record.id).then((data) => {
            this.fetchList(benefitsPage);
          })
        }
      }
    }
  } 

  get modalProps() {
    const { system,actions } = this.props
    const { currentBenefits, benefitsModalVisible,benefitsPage, benefitsModalType,submitBenefitsPending , benefitsTypeTree } = system

    const { benefitsModalChange,submitBenefits , getAllBenifits} = actions;
    const editItem  = benefitsModalType === 'create' ? {} : currentBenefits
    return {
      item: benefitsModalType === 'create' ? {} : currentBenefits,
      visible: benefitsModalVisible,
      destroyOnClose: true,
      maskClosable: false,
      confirmLoading: submitBenefitsPending,
      title: `${
        benefitsModalType === 'create' ? `创建` : `更新`
      }`,
      centered: true,
      elements: [
          {
            key: "pid",
            label: "父级",
            initialValue: editItem.pid,
            widget: TreeSelect,
            widgetProps:{
              treeData:benefitsTypeTree,
              treeDefaultExpandAll:false,
              onChange:this.onChange,
            },
            required: false
        },
        {
          key: "name",
          label: "标签名",
          initialValue: editItem.name,
          widget: Input,
          required: true
        },
        {
          key: "orderNum",
          label: "排序号",
          initialValue: editItem.orderNum,
          widget: Input,
          required: true
        },
      ],
      onOk: data => {
        submitBenefits(Object.assign({},data,{})).then(data=> {
          benefitsModalChange(false,"create");
          this.fetchList(benefitsPage);
          getAllBenifits();
        })
      },
      onCancel() {
        benefitsModalChange(false,"create");
      },
    }
  }

  get filterProps() {
    const { actions,system } = this.props
    const { currentBenefits,benefitsPage} = system
    const { benefitsModalChange } = actions;

    return {
      title:"",
      searchElements: [
        {
            key: "name",
            widget: Input,
            widgetProps:{
                placeholder:"请输入标签名"
            },
        },
      ],
      onFilterChange: value => {
         this.fetchList(1,value)
      },
      onAdd() {
        benefitsModalChange(true,'create')
      },
    }
  }

  get buttonProps() {
    const { actions,system } = this.props
    const { currentBenefits,benefitsPage} = system
    const { benefitsModalChange } = actions;

    return {
        buttons:[
            {
                name:"新增",
                buttonProps:{
                    type:"primary",
                    icon:"plus",
                },
                onClick:()=>{ benefitsModalChange(true,'create')}
            }
        ]
    }
  }

  render() {
    return (
      <Page inner>
        <CrudFilter {...this.filterProps} />
        <CrudButtons {...this.buttonProps} />
        <CrudTable {...this.listProps} />
        <CrudForm {...this.modalProps} />
      </Page>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    system: state.system,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BenefitsPage);


// WEBPACK FOOTER //
// ./src/features/system/BenefitsPage.js